import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';

export enum TransactionAttachmentType {
    SHIPPING_NOTES = 'shipping_notes'
}

export interface TransactionAttachment {
    user_id: string | null;
    type: TransactionAttachmentType | null;
    update_timestamp: string;
    id: string;
    account_id: string;
    transaction_id: string;
    creation_timestamp: string;
}

export interface CreateTransactionAttachment {
    user_id?: string | null;
    type?: TransactionAttachmentType | null;
    update_timestamp?: string;
}

enum QueryParams {
    ACCOUNT_ID = 'account_id',
    TRANSACTION_ID = 'transaction_id',
    USER_ID = 'user_id'
}
export type TransactionAttachmentQueryParams = QueryParams & DefaultQueryParams;
export type TransactionAttachmentListResponse = PaginatedResponse<TransactionAttachment>;
